import MarketplaceWidgetErrorBoundary from "./MarketplaceWidgetErrorBoundary";

export { MarketplaceWidgetErrorBoundary };